import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, Validators} from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef
} from '@angular/material/dialog';
import {OpenProjectDialogComponent} from '../open-project-dialog/open-project-dialog.component';
import {CommonModule} from '@angular/common';
import {UserPickerComponent} from '../../shared/components/user-picker.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'app-contact-picker-dialog',
    templateUrl: './contact-picker-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogContent,
        UserPickerComponent,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatDatepickerModule,
        MatDialogActions,
        MatButtonModule
    ]
})
export class ContactPickerDialogComponent implements OnInit {

    public showOnlyUser = false;

    public myControl: UntypedFormControl = new UntypedFormControl(undefined,
        Validators.required);
    public deliveryDateControl: UntypedFormControl = new UntypedFormControl(undefined,
        Validators.required);
    public noteToPrjMgr: UntypedFormControl = new UntypedFormControl();
    public minDate = new Date();

    constructor(
        public dialogRef: MatDialogRef<ContactPickerDialogComponent | OpenProjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.showOnlyUser = data ? data.showOnlyUser : false;
    }

    ngOnInit() {

    }

    closeDialog() {
        if (
            (this.myControl.valid && this.deliveryDateControl.valid) ||
            (this.showOnlyUser && this.myControl.valid)
        ) {
            this.dialogRef.close({
                user: this.myControl.value,
                deliveryThr: this.deliveryDateControl.value,
                noteToPrjMgr: this.noteToPrjMgr.value
            });
        } else {
            this.deliveryDateControl.markAsTouched({onlySelf: true});
        }
    }


    onNoClick(): void {
        this.dialogRef.close();
    }

}